import DashboardLayout from '../../components/DashboardLayout'
import OrgCollectionForm from '@components/OrgCollectionForm'
import useCreateOrgCollectionPage from './useCreateOrgCollectionPage'

export default function CreateOrgCollectionPage() {
    const {
        values,
        setValue,
        handleSubmit,
        formValid,
        loading,
        error,
        admins,
        orgs,
        validationErrors,
    } = useCreateOrgCollectionPage()

    return (
        <DashboardLayout>
            <OrgCollectionForm
                title="Create New Org Collection"
                values={values}
                setValue={setValue}
                formValid={formValid}
                handleSubmit={handleSubmit}
                loading={loading}
                error={error}
                validationErrors={validationErrors}
                admins={admins}
                orgs={orgs}
            />
        </DashboardLayout>
    )
}
